import { render, staticRenderFns } from "./appCurrencySelect.vue?vue&type=template&id=86a3548c"
import script from "./appCurrencySelect.vue?vue&type=script&lang=js"
export * from "./appCurrencySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports